module.exports = __webpack_public_path__ + "a768e7de/img/mini-logo.18817ee5.svg";